import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-footer-terms',
    templateUrl: './footer-terms.component.html',
    styleUrls: ['./footer-terms.component.less']
})
export class FooterTermsComponent implements OnInit {
    isExternalTermsOrPrivacy = false;
    currentYear: number;
    constructor(private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        this.isExternalTermsOrPrivacy = this.route.snapshot.data.isExternalTermsOrPrivacy;
    }

}
